import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/store/marketplace/shippo',
    name: 'ShippoMarketplace',
    component: () => import('../pages/ShippoMarketPlacePage.vue'),
  },
  {
    path: '/store/marketplace/shipstation',
    name: 'ShipStationMarketplace',
    component: () => import('../pages/ShipStationMarketPlacePage.vue'),
  },
  {
    path: '/store/marketplace/printify',
    name: 'PrintifyMarketplace',
    component: () => import('../pages/PrintifyMarketPlacePage.vue'),
  },
  {
    path: '/store/marketplace/success',
    name: 'MarketplaceAuthSuccess',
    component: () => import('../pages/MarketplaceAuthSuccess.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
